import React from 'react'
import PharmaciesList from '../PharmaciesList/PharmaciesList'
import GeozonesList from '../Geozone/GeozonesList'
import SurgeriesList from '../Surgeries/SurgeriesList'
import SurgeryDetails from '../Surgeries/SurgeryDetails'
import CreateOrganisation from '../CreateOrganisation/CreateOrganisationContainer'
import Search from '../Search/Search'
import PharmacyDetails from '../PharmacyDetails/PharmacyDetailsContainer'
import BranchDetails from '../BranchDetails/BranchDetails'
import GeoZoneDetails from '../Geozone/GeozoneDetails'
import CreateBranch from '../CreateBranch/CreateBranchContainer'
import CreateGeozone from '../Geozone/CreateGeozone'
import PharmacyOrderList from '../PharmacyOrderList/PharmacyOrderList'
import ProblematicPharmaciesList from '../PharmacyOrderList/ProblematicPharmaciesList'
import WhiteLabelList from '../WhiteLabels/WhiteLabelList';
import WhiteLabelDetails from '../WhiteLabels/WhiteLabelDetails';
import DeliveryGeofenceMap from '../DeliveryGeofenceMap/DeliveryGeofenceMap';
import BillingDetails from '../BillingDetails/BillingDetails'
import CreateNewBranch from '../CreateNewBranch/CreateNewBranch'
import AuditLogs from '../AuditLogs/AuditLogs';
import ECommerceBanner from '../ECommerce/Ecommerce';
import ECommerceCategory from '../ECommerce/Categories';
import OrderPage from '../Order/OrderPage';
import ECommerceGeofenceMap from '../ECommerceGeofenceMap/ECommerceGeofenceMap'
import ServiceConditions from '../Services/ServiceConditions';
import ServiceConditionDetails from '../Services/ServiceConditions/ServiceConditionDetails';
import ServiceDetails from '../Services/ServiceDetails';
import AnnouncementsList from '../Announcements/AnnouncementsList'
import AnnouncementCreate from '../Announcements/CreateAnnouncement';
import PushNotificationsList from '../Campaigns/PushNotifications/PushNotificationsContainer';
import PushNotificationDetailsContainer from '../Campaigns/PushNotifications/PushNotificationDetailsContainer';
import CreatePushNotificationContainer from '../Campaigns/PushNotifications/CreatePushNotificationContainer';
import Consultations from '../Services/Consultations'
import QuestionnairesList from '../Questionnaires/QuestionnairesList/QuestionnairesList'
import Questionnaire from '../Questionnaires/QuestionnairePage/QuestionnairePage'
import ClinicsList from '../Clinics/ClinicsList/ClinicsList'
import CreateClinic from '../Clinics/CreateClinic/CreateClinic';
import ModifyClinicContainer from '../Clinics/ModifyClinic/ModifyClinicContainer';
import MasterMedicineContainer from '../MasterMedicines/containers/MasterMedicineContainer'
import MasterMedicinesTable from '../MasterMedicines/MasterMedicineTable'
/* plop:append-imports */
import ClinicMasterProductTable from '../ClinicMasterProduct/ClinicMasterProductTable';
import CreateClinicMasterProductContainer from '../ClinicMasterProduct/containers/CreateClinicMasterProductContainer';
import ModifyClinicMasterProductContainer from '../ClinicMasterProduct/containers/ModifyClinicMasterProductContainer'
import VirtualMedicineContainer from '../VirtualMedicine/containers/VirtualMedicineContainer';

export const Pharmacies = () => <PharmaciesList />
export const Geozones = () => <GeozonesList />;
export const DeliveryGeofenceMapPage = () => <DeliveryGeofenceMap />;
export const ECommerceGeofenceMapPage = () => <ECommerceGeofenceMap />;
export const WhiteLabels = () => <WhiteLabelList />;
export const WhiteLabelDetail = () => <WhiteLabelDetails />;
export const ECommerceBanners = () => <ECommerceBanner />;
export const ECommerceCategories = () => <ECommerceCategory />;
export const Surgeries = () => <SurgeriesList />
export const SurgeryDetailsPage = () => <SurgeryDetails />
export const CreateOrganisationPage = () => <CreateOrganisation />
export const SearchBar = () => <Search />
export const PharmacyDetailsPage = () => <PharmacyDetails />
export const BranchDetailsPage = () => <BranchDetails />
export const GeozoneDetailsPage = () => <GeoZoneDetails />
export const CreateGeozonePage = () => <CreateGeozone />
export const CreateBranchPage = () => <CreateBranch />
export const ProblematicPharmaciesListPage = () => <ProblematicPharmaciesList />

export const ServiceDetailsPage = () => <ServiceDetails />
export const ServiceConditionsPage = () => <ServiceConditions />
export const ServiceConditionDetailsPage = () => <ServiceConditionDetails />
export const ServiceConsultationsPage = () => <Consultations />

export const PharmacyOrderListPage = () => <PharmacyOrderList />

export const OrderDetailsPage = () => <OrderPage />

export const BillingDetailsPage = () => <BillingDetails />
export const CreateNewBranchPage = () => <CreateNewBranch />

export const AuditLogsPage = () => <AuditLogs />

export const AnnouncementsListPage = () => <AnnouncementsList />;
export const AnnouncementCreatePage = () => <AnnouncementCreate />;

export const PushNotificationsListPage = () => <PushNotificationsList />;
export const PushNotificationDetailsPage = () => <PushNotificationDetailsContainer />
export const CreatePushNotificationPage = () => <CreatePushNotificationContainer />

export const QuestionnairesListPage = () => <QuestionnairesList />;
export const QuestionnairePage = () => <Questionnaire />;

export const ClinicsPage = () => <ClinicsList />;
export const CreateClinicPage = () => <CreateClinic />;
export const ModifyClinicPage = () => <ModifyClinicContainer />;

export const MasterMedicinesPage = () => <MasterMedicinesTable />;
export const MasterMedicinePage = () => <MasterMedicineContainer />;

/* plop:append-exports */
export const ClinicMasterProductsPage = () => <ClinicMasterProductTable />;
export const ModifyClinicMasterProductPage = () => <ModifyClinicMasterProductContainer />;
export const CreateClinicMasterProductPage = () => <CreateClinicMasterProductContainer />;
export const VirtualMedicinePage = () => <VirtualMedicineContainer />;
